import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/employeePosition/findAll')
    return data
  },

  async findByEmployee(employeeId) {
    const { data } = await repository.get(baseURL + '/employeePosition/findByEmployee/' + employeeId)
    return data
  },

  async findAllByEmployee(employeeId) {
    const { data } = await repository.get(baseURL + '/employeePosition/findAllByEmployee/' + employeeId)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/employeePosition', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/employeePosition', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/employeePosition/' + id)
  }
}
